import { Injectable, inject } from '@angular/core';
import { Loader } from '@googlemaps/js-api-loader';
import { AppConfigService } from '@services/app-configuration.service';
import { EventManagerService } from '@services/event-manager.service';
import { defaultConfig } from 'src/app/app.config';

const { configLoaded } = defaultConfig.appEvents;

@Injectable({
  providedIn: 'root',
})
export class GoogleMapsLoaderService {
  protected _appConfig = inject(AppConfigService);
  protected _eventManager = inject(EventManagerService);

  private apiKey = '';
  private loader: Loader | null = null;
  private mapsLoaded = false;

  private configReadyResolver!: () => void;
  private configReady = new Promise<void>(resolve => {
    this.configReadyResolver = resolve;
  });

  constructor() {
    this._eventManager.subscribe(configLoaded.name, () => this.initService());
  }

  initService() {
    const googleApiKey = this._appConfig.getParameter('googleApiKey');
    if (googleApiKey) {
      this.apiKey = googleApiKey;
      this.loader = new Loader({
        apiKey: this.apiKey,
        version: 'weekly',
        libraries: ['places', 'marker'], // agrega librerías necesarias aquí
      });
      this.configReadyResolver();
    }
  }
  async loadGoogleMaps(): Promise<void> {
    await this.configReady;
    if (this.mapsLoaded) {
      return;
    }
    if (!this.loader) {
      throw new Error('Google Maps Loader not initialized');
    }
    await Promise.all([
      this.loader.importLibrary('maps'),
      this.loader.importLibrary('places'),
      this.loader.importLibrary('marker'),
    ]);
    this.mapsLoaded = true;
  }
}
